const LOGO_VISIBLE_DURATION = 5000;
const LOGO_TRANSITION_DURATION = 500;

function createLogoRotator(column, columnIndex) {
	const logos = Array.from(column.children);
	if (!logos.length) {
		return () => {};
	}

	let activeIndex = 0;
	let timer = null;
	let transitionTimer = null;
	const animationFrames = new Set();
	const direction = columnIndex % 2 === 0 ? 'vertical' : 'horizontal';

	logos.forEach((logo, index) => {
		logo.classList.toggle('is-active', index === 0);
		logo.dataset.logoDirection = direction;
	});

	if (logos.length === 1 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
		return () => {};
	}

	const requestFrame = (callback) => {
		const frame = window.requestAnimationFrame(() => {
			animationFrames.delete(frame);
			callback();
		});

		animationFrames.add(frame);
	};

	const clearScheduledWork = () => {
		window.clearTimeout(timer);
		window.clearTimeout(transitionTimer);
		animationFrames.forEach((frame) => window.cancelAnimationFrame(frame));
		animationFrames.clear();
		timer = null;
		transitionTimer = null;
	};

	const normalizeLogos = () => {
		logos.forEach((logo, index) => {
			logo.classList.remove('is-entering', 'is-exiting');
			logo.classList.toggle('is-active', index === activeIndex);
		});
	};

	const scheduleAdvance = (
		delay = LOGO_VISIBLE_DURATION + LOGO_TRANSITION_DURATION
	) => {
		window.clearTimeout(timer);
		timer = window.setTimeout(advance, delay);
	};

	function advance() {
		if (document.hidden) {
			return;
		}

		const current = logos[activeIndex];
		activeIndex = (activeIndex + 1) % logos.length;
		const next = logos[activeIndex];
		const offset = Math.random() > 0.5 ? '200%' : '-200%';

		current.style.setProperty('--fc-logo-offset', offset);
		current.classList.remove('is-active');
		current.classList.add('is-exiting');
		next.style.setProperty('--fc-logo-offset', offset);
		next.classList.add('is-entering');

		requestFrame(() => {
			requestFrame(() => {
				next.classList.remove('is-entering');
				next.classList.add('is-active');
			});
		});

		transitionTimer = window.setTimeout(
			() => current.classList.remove('is-exiting'),
			LOGO_TRANSITION_DURATION
		);
		scheduleAdvance();
	}

	const handleVisibilityChange = () => {
		clearScheduledWork();
		normalizeLogos();

		if (!document.hidden) {
			scheduleAdvance(LOGO_VISIBLE_DURATION);
		}
	};

	document.addEventListener('visibilitychange', handleVisibilityChange);
	if (!document.hidden) {
		scheduleAdvance(LOGO_VISIBLE_DURATION + columnIndex * 200);
	}

	return () => {
		clearScheduledWork();
		document.removeEventListener(
			'visibilitychange',
			handleVisibilityChange
		);
	};
}

function initLogoSlider(block) {
	const columns = Array.from(block.querySelectorAll('.brands__item'));
	if (!columns.length || block.dataset.fcLogoSliderInit) {
		return;
	}

	block.dataset.fcLogoSliderInit = '1';
	const originalColumns = columns.map((column) =>
		Array.from(column.children).map((logo) => logo.cloneNode(true))
	);
	const mobileMedia = window.matchMedia('(max-width: 599px)');
	let cleanups = [];

	const render = () => {
		cleanups.forEach((cleanup) => cleanup());
		cleanups = [];
		columns.forEach((column) => column.replaceChildren());

		if (mobileMedia.matches) {
			originalColumns.flat().forEach((logo) => columns[0].append(logo.cloneNode(true)));
			cleanups.push(createLogoRotator(columns[0], 0));
			return;
		}

		originalColumns.forEach((logos, index) => {
			logos.forEach((logo) => columns[index].append(logo.cloneNode(true)));
			cleanups.push(createLogoRotator(columns[index], index));
		});
	};

	render();
	mobileMedia.addEventListener('change', render);
}

function initLogoSliders() {
	document.querySelectorAll('.wp-block-fc-block-fc-logo-slider').forEach(initLogoSlider);
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initLogoSliders);
} else {
	initLogoSliders();
}
